import React from 'react';
import styled from 'styled-components/macro';

import useMedia from 'hooks/useMedia';

import Box from 'components/elements/Box';
import P from 'components/elements/p';
import { ReactComponent as IconDSPSpikes } from 'icons/dsp-spikes-legend.svg';

const Line = styled('span')<any>`
  display: block;
  width: 35px;
  border-top: ${({ color, lineType, thickness = 2 }): string =>
    `${thickness}px ${lineType} ${color}`};
`;

const Circle = styled('span')<any>`
  display: block;
  height: 8px;
  width: 8px;
  background-color: ${({ circleBackground = '#9B9B9B' }): string =>
    circleBackground};
  border-radius: 50%;
  border: ${({ circleBorder = '#fff' }): string =>
    `1.5px solid ${circleBorder}`};
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.204573);
`;

const StyledIcon = styled.svg``;

interface ILegendItem {
  lineType?: string;
  lineColor?: string;
  lineThickness?: number;
  circleBorder?: string;
  circleBackground?: string;
  iconType?: string;
  text: string;
  text2?: string;
  isSpikes?: boolean;
}

const Legend: React.FC<{ hasSpikes?: boolean }> = ({ hasSpikes = false }) => {
  const defaultLineColor = '#9b9b9b';
  const lines: ILegendItem[] = [
    { lineType: 'solid', text: 'Solid line:', text2: 'Available data' },
    {
      lineType: 'dotted',
      text: 'Dashed line:',
      text2: 'Unavailable or Incomplete Data',
    },
    {
      iconType: 'image',
      text: 'Weekly data spikes:',
      text2: 'A few DSPs provide a sum of the week’s data once every week',
      isSpikes: true,
    },
  ];
  const isLargeScreen = useMedia('(min-width: 50em)');

  return (
    <Box
      display="flex"
      flexWrap="wrap"
      justifyContent="space-between"
      pl={isLargeScreen ? '60px' : '8px'}
    >
      {lines.map((item: ILegendItem, index: number) => {
        const {
          lineType,
          lineColor,
          lineThickness,
          circleBorder,
          circleBackground,
          iconType,
          text,
          text2,
          isSpikes,
        } = item;
        if (!hasSpikes && isSpikes) return null;
        const icon = isSpikes && hasSpikes ? IconDSPSpikes : 'div';

        return (
          <Box
            key={index}
            display="flex"
            alignItems="center"
            mr={5}
            flexGrow={isLargeScreen ? 1 : 0}
          >
            <Box display="flex" alignItems="center" mr={3}>
              {iconType === 'image' ? (
                <Box
                  width="43px"
                  height="43px"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <StyledIcon as={icon} />
                </Box>
              ) : (
                <>
                  <Line
                    lineType={lineType}
                    color={lineColor || defaultLineColor}
                    thickness={lineThickness}
                  />
                  <Circle
                    circleBorder={circleBorder}
                    circleBackground={circleBackground}
                  />
                </>
              )}
            </Box>
            <P my={0} color="#8AA4C3" fontSize="13.33px" lineHeight="16px">
              {text}&nbsp;{isLargeScreen && <br />}
              {text2}
            </P>
          </Box>
        );
      })}
    </Box>
  );
};

export default Legend;
